import { Button, Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import { DemandIems } from "../../services/items";
import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext";
import { PlusCircleOutlined } from "@ant-design/icons";

export default function DemandLetterItemsForm() {
  const { demandLetterItemdispatch } = useApiContext();
  const [demanditemForm] = Form.useForm();
  const [itemProfession, setItemProfession] = useState("");
  const [itemOccupation, setItemOccupation] = useState("");
  const [itemMale, setItemMale] = useState("");
  const [itemFemale, setItemFemale] = useState("");
  const [itemSalary, setItemSalary] = useState("");
  const [itemRemarks, setItemRemarks] = useState("");
  const [itemDailyHours, setItemDailyHours] = useState("");
  const [itemTotal, setItemTotal] = useState(0);

  const handleTotal = (value) => {
    setItemFemale(value);
    setItemTotal(itemMale * value);
  };

  const addDemandItemSubmit = () => {
    let newValues = {
      id: uuid(),
      profession: itemProfession,
      occupation: itemOccupation,
      male: itemMale,
      female: itemFemale,
      itemtotal: itemTotal,
      salary: itemSalary,
      itemdailyHours: itemDailyHours,
    };
    DemandIems.add(demandLetterItemdispatch, newValues);
    demanditemForm.resetFields();
    setItemTotal(0);
    console.log("Damand items", newValues);
  };
  return (
    <Form
      form={demanditemForm}
      layout="vertical"
      name="horizontal_login"
      style={{ width: "100%" }}
    >
      <Col span={24}>
        <Row>
          <Col span={6}>
            <Form.Item
              name="profession"
              rules={[{ required: true, message: "Please Enter Profession" }]}
              label="Profession"
            >
              <Input
                placeholder="Profession"
                onChange={(e) => setItemProfession(e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="occupation"
              rules={[{ required: true, message: "Please enter Occupation" }]}
              label="Occupation"
            >
              <Input
                onChange={(e) => setItemOccupation(e.target.value)}
                placeholder="Occupation"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="male" label="Male">
              <Input
                onChange={(e) => setItemMale(e.target.value)}
                placeholder="Male"
                type="number"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="female" label="Female">
              <Input
                onChange={(e) => handleTotal(e.target.value)}
                placeholder="Female"
                type="number"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="total" label="Total">
              <label>{itemTotal}</label>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="salary"
              rules={[{ required: true, message: "Please enter Salary" }]}
              label="Salary"
            >
              <Input
                onChange={(e) => setItemSalary(e.target.value)}
                placeholder="Salary"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="itemdailyhours"
              rules={[{ required: true, message: "Please enter Remarks" }]}
              label="Daily Hours"
            >
              <Input
                onChange={(e) => setItemDailyHours(e.target.value)}
                placeholder="Remarks"
              />
            </Form.Item>
          </Col>
          <Col span={3} offset={1}>
            <Form.Item label="">
              <Button
                style={{ marginTop: "32px" }}
                type="primary"
                icon={<PlusCircleOutlined />}
                onClick={addDemandItemSubmit}
              >
                Add Item
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Form>
  );
}
